import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const GeometricPatternIcon = React.memo(function ({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="2.5" y="2.5" width="10" height="10" rx="0.5" stroke={color} />
      <path d="M7 8L5.5 9.5L4 11H7V8Z" fill={color} fillOpacity="0.4" />
      <rect
        x="8"
        y="4"
        width="3"
        height="3"
        rx="1.5"
        fill={color}
        fillOpacity="0.4"
      />
      <rect x="8" y="8" width="3" height="3" fill={color} fillOpacity="0.4" />
      <rect x="4" y="4" width="3" height="3" fill={color} fillOpacity="0.6" />
    </svg>
  );
});
